type Kind = "Video" | "Exercise" | "Article" | "Scratchpad" | "Practice";

export const FILTERABLE_KINDS: ReadonlyArray<Kind> = [
    "Video",
    "Exercise",
    "Article",
    "Scratchpad",
];

// We want to coalesce scratchpads with exercises, since they're interactive-y
// and rare enough that it doesn't warrant a dedicated filter label, so
// add in a level of indirection from kind to filter key.
export const filterKeyForKind = (kind: Kind): Kind => {
    if (kind === "Scratchpad" || kind === "Exercise") {
        return "Practice";
    }
    return kind;
};

export const applyFilterToItem = (filterKey: string, item: any): boolean => {
    if (!filterKey || filterKey === "All") {
        return true;
    }
    if (filterKey === "Practice") {
        return item.kind === "Exercise" || item.kind === "Scratchpad";
    }
    return item.kind === filterKey;
};
